import React from 'react';
import { readAssignments } from '../utils/companyAssignments';

const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5001';

const getAvatarUrl = (employee) => {
  if (employee?.avatar?.filePath) {
    return `${apiUrl}/${employee.avatar.filePath.replace(/\\/g, '/')}`;
  }

  return null;
};

const getInitials = (employee) =>
  `${employee?.firstName?.charAt(0) || ''}${employee?.lastName?.charAt(0) || ''}`.toUpperCase();

const formatDate = (value) => {
  if (!value) {
    return '-';
  }

  return new Date(value).toLocaleDateString('tr-TR', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
};

const EmployeeDetailModal = ({ employee, isOpen, onClose }) => {
  if (!isOpen || !employee) {
    return null;
  }

  const avatarUrl = getAvatarUrl(employee);
  return (
    <>
      <div className="modal-backdrop fade show" onClick={onClose}></div>
      <div className="modal fade show d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content directory-modal">
            <div className="modal-header border-0 pb-0">
              <div>
                <h5 className="modal-title">Çalışan Profili</h5>
                <p className="text-muted mb-0">Onaylı rehber kaydı ve iletişim detayları</p>
              </div>
              <button type="button" className="btn-close" onClick={onClose} aria-label="Close"></button>
            </div>

            <div className="modal-body">
              <div className="row g-4">
                <div className="col-md-4">
                  <div className="directory-modal-profile">
                    <div className="directory-modal-avatar">
                      {avatarUrl ? (
                        <img src={avatarUrl} alt={`${employee.firstName} ${employee.lastName}`} />
                      ) : (
                        <div className="directory-modal-avatar-fallback">{getInitials(employee)}</div>
                      )}
                    </div>
                    <h4>{employee.firstName} {employee.lastName}</h4>
                    <p>{employee.position}</p>
                  </div>
                </div>

                <div className="col-md-8">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <div className="directory-modal-field">
                        <small>E-posta</small>
                        <a href={`mailto:${employee.email}`}>{employee.email}</a>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="directory-modal-field">
                        <small>Cep telefonu</small>
                        <span>{employee.phone || '-'}</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="directory-modal-field">
                        <small>Dahili numara</small>
                        <span>{employee.extension || '-'}</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="directory-modal-field">
                        <small>Lokasyon</small>
                        <span>{employee.officeLocation || '-'}</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="directory-modal-field">
                        <small>Ofis bina numarası</small>
                        <span>{employee.officeBuilding || '-'}</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="directory-modal-field">
                        <small>Kat</small>
                        <span>{employee.officeFloor || '-'}</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="directory-modal-field">
                        <small>İşe başlangıç</small>
                        <span>{formatDate(employee.startDate)}</span>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="directory-modal-field">
                        <small>Şirket ve departman</small>
                        {readAssignments(employee).filter((row) => row.companyName || row.department).map((row) => (
                          <span key={`${row.companyId}-${row.department}`}>{[row.companyName, row.department, row.region].filter(Boolean).join(' · ')}</span>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer border-0">
              <a className="btn btn-primary" href={`mailto:${employee.email}`}>
                E-posta gönder
              </a>
              {employee.phone && (
                <a className="btn btn-outline-primary" href={`tel:${employee.phone}`}>
                  Telefon et
                </a>
              )}
              <button type="button" className="btn btn-secondary" onClick={onClose}>
                Kapat
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EmployeeDetailModal;
